import { LanguageCode } from "./language"

export namespace LocalStorage {
    const IS_SELECTED_LOCALE = 'IS_SELECTED_LOCALE'
    const IS_USE_NIGHT_THEME = 'IS_USE_NIGHT_THEME'
    const IS_LOGIN_NAME = 'IS_LOGIN_NAME'
        
    const remove = (key: string) => { localStorage.removeItem(key) }

    export const getSelectedLocale = (): LanguageCode => _get(IS_SELECTED_LOCALE)
    export const getIsDarkMode = (): boolean => _get(IS_USE_NIGHT_THEME) || false
    export const saveSelectedLocale = (selectedLocale: LanguageCode) => _save(IS_SELECTED_LOCALE, selectedLocale)
    export const saveDarkMode = (darkMode: boolean) => _save(IS_USE_NIGHT_THEME, darkMode)
    export const getLoginName = (): string => _get(IS_LOGIN_NAME) || ''
    export const saveLoginName = (email: string | null) => { if( email !== null ) _save(IS_LOGIN_NAME, email) }
    
    const _get = (key: string) => _doSafe(key, (storage: Storage) => {
        const value = storage.getItem(key)
        return value && JSON.parse(value)
    })

    const _save = (key: string, data: any = null) => { _doSafe(key, (storage: Storage) => storage.setItem(key, JSON.stringify(data))) }

    const _doSafe = <T>(key: string, fn: (storage: Storage) => T) => {
        try {
            return fn(localStorage)
        } catch (e) {
            console.error("ERROR", e)
            remove(key)
        }
    }
}